module.exports = __webpack_public_path__ + "img/20190817131450241.9354091e.png";